import { wrapTransformerWithKlearClasses } from '@klear/registry/class'
import { primitiveTransformer } from '@klear/registry/primitive-transformer'
import { CLASS_REGISTRY } from '@klear/registry'

export const klearTransformer = wrapTransformerWithKlearClasses(primitiveTransformer, CLASS_REGISTRY)
